export const transactions = {
    layout: {
        newFinancingTitle: 'Novo Financiamento',
        newTransactionTitle: 'Nova Transação',
        editOccurrenceTitle: 'Editar ocorrência',
        editTransactionTitle: 'Editar Transação',
        monthScreenTitle: 'Transações do mês',
        recentScreenTitle: 'Despesas recentes',
        newCategoryTitle: 'Nova Categoria',
    },
    list: {
        title: 'Transações',
        searchPlaceholder: 'Buscar por nome ou valor...',
        searchScopeMonth: 'Neste mês',
        searchScopeAll: 'Todo o período',
        typeAll: 'Todas',
        typeIncome: 'Receitas',
        typeExpense: 'Despesas',
        typeTransfer: 'Transferências',
        completedSection: 'Concluídas',
        overdueSection: 'Atrasadas',
        thisMonthSection: 'Este mês',
        dayBalance: 'Saldo do dia {{value}}',
        dayProjectedBalance: 'Saldo previsto {{value}}',
        emptyTitle: 'Nenhuma transação',
        emptySubtitle: 'Use o botao + para adicionar',
        emptySearchTitle: 'Nenhum resultado',
        emptySearchTryAnotherTerm: 'Tente outro termo',
        emptySearchTryAllTime: 'Tente buscar em "Todo o período"',
    },
    selection: {
        cancel: 'Cancelar',
        selectAll: 'Tudo',
        selectedCount_one: '{{count}} selecionada',
        selectedCount_other: '{{count}} selecionadas',
    },
    calendar: {
        toggleA11y: 'Ver fluxo de caixa em calendário',
        listA11y: 'Ver lista de lançamentos',
        weekdaySun: 'D',
        weekdayMon: 'S',
        weekdayTue: 'T',
        weekdayWed: 'Q',
        weekdayThu: 'Q',
        weekdayFri: 'S',
        weekdaySat: 'S',
        includePendingTitle: 'Considerar não efetivados',
        includePendingChip: 'Não efetivados',
        includePendingHint: 'Soma pendentes, recorrências previstas e faturas de cartão em aberto.',
        modeBalance: 'Saldo',
        modeMovement: 'Movimento',
        dayA11y: 'Dia {{day}}, saldo {{amount}}',
        dayMovementA11y: 'Dia {{day}}, movimento {{amount}}',
        detailClose: 'Fechar',
        detailNoDelta: 'Sem movimento',
        detailDayMovement: 'Movimento do dia',
        detailDayEnd: 'Fim do dia',
        addOnThisDay: 'Lançar neste dia',
        locked: {
            badge: 'PRO',
            title: 'Descubra o dia em que seu caixa fura',
            subtitle: 'O saldo de cada dia do mês, incluindo contas e faturas que ainda não caíram.',
            cta: 'Desbloquear com o Pro',
            dismiss: 'Agora não',
        },
        emptyTitle: 'Sem contas para somar',
        emptySubtitle: 'O calendário usa as contas que entram no saldo total. Inclua ao menos uma para ver o fluxo.',
    },
    batch: {
        category: 'Categoria',
        tag: 'Tag',
        delete: 'Excluir',
        deleteDialog: {
            title: 'Excluir em lote',
            message: 'Excluir {{total}} transações?',
            confirm: 'Excluir',
        },
        tagSheet: {
            title: 'Adicionar tag',
            message: 'Selecione a tag:',
        },
    },
    recurringDeleteSheet: {
        title: 'Excluir transação',
        message: 'Esta transação se repete. O que você deseja excluir?',
        onlyThis: 'Apenas esta',
        onlyThisDescription: 'Remove só este lançamento.',
        thisAndNext: 'Esta e as próximas',
        thisAndNextDescription: 'Apaga esta ocorrência e as seguintes.',
        all: 'Todas',
        allDescription: 'Exclui toda a série recorrente.',
    },
    month: {
        titlePay: 'Pagar',
        titleReceive: 'Receber',
        titleInvoices: 'Faturas',
        titleTransfers: 'Transferências agendadas',
        titleTagFallback: 'Tag',
        titleOthers: 'Outros',
        titleCategoryFallback: 'Categoria',
        titleStatement: 'Extrato',
        titleIncome: 'Receitas',
        titleExpense: 'Despesas',
        confirmedLabel: 'Confirmado',
        receivedLabel: 'Recebido',
        paidLabel: 'Pago',
        confirmedOfTotal: '{{label}}: {{amount}}',
        transactionCount_one: '{{count}} transação',
        transactionCount_other: '{{count}} transações',
        // Filtros herdados do Relatório personalizado, na linha abaixo da contagem.
        filterSettled: 'Concluídas',
        filterPending: 'Pendentes',
        filterAccounts_one: '{{count}} conta',
        filterAccounts_other: '{{count}} contas',
        filterCategories_one: '{{count}} categoria',
        filterCategories_other: '{{count}} categorias',
        completedSection: 'Concluídas',
        periodMonth: 'neste mês',
        periodCustom: 'neste período',
        searchPlaceholder: 'Buscar nesta lista...',
        empty: {
            allTitle: 'Nenhuma transação',
            invoicesTitle: 'Nenhuma fatura',
            incomeTitle: 'Nenhuma receita',
            expenseTitle: 'Nenhuma despesa',
            allSubtitle: 'Nenhuma transação {{period}}',
            invoicesSubtitle: 'Nenhuma fatura {{period}}',
            incomeSubtitle: 'Nenhuma receita {{period}}',
            expenseSubtitle: 'Nenhuma despesa {{period}}',
            searchTitle: 'Nenhum resultado',
            searchSubtitle: 'Nada com esse nome ou valor nesta lista',
        },
    },
    recent: {
        emptyText: 'Nenhuma despesa encontrada',
        searchPlaceholder: 'Buscar nesta lista...',
        emptySearchText: 'Nenhuma das despesas recentes tem esse nome ou valor',
        installmentBadge: '{{times}}x',
    },
    form: {
        // Descrição default persistida quando o usuário deixa em branco (dado criado).
        // Fora a transferência, o padrão é o NOME DA CATEGORIA — resolvido no formulário.
        defaults: {
            transferDescription: 'Transferência entre contas',
        },
        title: {
            duplicate: 'Duplicar lançamento',
            newRefund: 'Novo estorno',
            newFinancing: 'Novo Financiamento',
            newLoanContract: 'Novo Empréstimo',
            editFinancing: 'Editar financiamento',
            editLoanContract: 'Editar empréstimo',
            newLoan: 'Novo valor a receber',
            newCardExpense: 'Nova Despesa no Cartão',
            newIncome: 'Nova Receita',
            newTransfer: 'Nova Transferência',
            newExpense: 'Nova Despesa',
            editExpense: 'Editar despesa',
            editIncome: 'Editar receita',
            editTransfer: 'Editar transferência',
        },
        amountLabel: {
            refund: 'Valor que voltou',
            financing: 'Valor da parcela mensal',
            loan: 'Valor a receber',
            income: 'Valor da receita',
            transfer: 'Valor da transferência',
            expense: 'Valor da despesa',
            installment: 'Valor da parcela',
        },
        // Selo "3/12" ao lado do rótulo do valor, com a compra de origem num balão.
        installmentBadge: {
            a11y: 'Parcela {{current}} de {{total}}',
            a11yPurchase: 'Parcela {{current}} de {{total}}, compra de {{amount}} em {{date}}',
            purchase: 'Compra',
            madeOn: 'Feita em',
            recorded: 'No app',
            lastInstallment: 'Última parcela',
            partialHint: 'Cadastrada a partir da {{first}}ª parcela',
        },
        dateFallback: 'Data',
        action: {
            registerRefund: 'Lançar estorno',
            createFinancing: 'Criar financiamento',
            createLoanContract: 'Criar empréstimo',
            saveContractChanges: 'Salvar contrato',
            registerLoan: 'Registrar valor a receber',
            saveOccurrence: 'Salvar ocorrência',
            saveAndCreateRecurrence: 'Salvar e criar recorrência',
            saveChanges: 'Salvar alterações',
            createRecurrence: 'Criar recorrência',
            transfer: 'Transferir',
            save: 'Salvar',
            saveAndContinue: 'Salvar e continuar',
        },
        a11y: {
            duplicateTransaction: 'Duplicar lançamento',
            deleteTransaction: 'Excluir lançamento',
            importReceipt: 'Importar comprovante',
        },
        confirmedToggle: {
            received: 'Recebido',
            paid: 'Pago',
        },
        fields: {
            timeLabel: 'Horário da compra',
            timeLabelIncome: 'Horário do recebimento',
            timeLabelTransfer: 'Horário da transferência',
            timeLabelRefund: 'Horário da devolução',
            descriptionPlaceholder: 'Descrição (opcional)',
            contractNamePlaceholder: 'Nome do contrato',
            category: 'Categoria',
            selectCategoryPlaceholder: 'Selecionar categoria...',
            suggestedCategory: 'Categoria sugerida: {{category}}',
            suggestedCategoryChange: 'Trocar',
            creditCard: 'Cartão de crédito',
            selectCardPlaceholder: 'Selecionar cartão...',
            account: 'Conta',
            selectAccountPlaceholder: 'Selecionar conta...',
            sourceAccount: 'Conta de origem',
            destinationAccount: 'Conta de destino',
            notesPlaceholder: 'Observações',
            tags: 'Tags',
        },
        details: {
            show: 'Mais detalhes',
            hide: 'Ocultar detalhes',
        },
        financing: {
            toggle: 'Financiamento ou empréstimo',
            kindFinancing: 'Financiamento',
            kindLoan: 'Empréstimo',
            kindFinancingHint: 'Um bem financiado — imóvel, carro, moto. As parcelas já estão definidas.',
            kindLoanHint: 'Dinheiro que você pegou com banco ou fintech. A parcela pode ficar em aberto e receber juros.',
            monthlyHint: 'Quanto você paga por mês — não o total do contrato.',
            typeSheetTitle: 'Que tipo de contrato?',
            typeSheetSubtitle: 'O Kontto passa a acompanhar as parcelas: cronograma, saldo devedor e quitação.',
            typeSheetKeepAsExpense: 'Continuar como despesa comum',
            contractRowTitle: 'É um contrato parcelado',
            contractRowSubtitle: 'Financiamento ou empréstimo, com parcelas a vencer',
            contractChip: 'Contrato parcelado',
            newFinancingTitle: 'Novo financiamento',
            newLoanTitle: 'Novo empréstimo',
            typeRowLabel: 'Tipo',
            calcRowLabel: 'Cálculo',
            calcSheetTitle: 'Como a parcela se comporta',
            calcSheetSubtitle: 'Se você não sabe, deixe em Parcela fixa — dá para trocar depois sem perder o histórico.',
            calcSheetConfirm: 'Usar {{system}}',
            systemDefaultBadge: 'padrão',
            fineTuningLabel: 'Juros, seguros e saldo devedor',
            rateFieldLabel: 'Juros do contrato',
            rateFieldUnit: '% ao ano',
            insuranceFieldLabel: 'Seguros e taxas',
            insuranceFieldNote: 'MIP/DFI',
            insuranceFieldUnit: '/mês',
            balanceFieldLabel: 'Saldo devedor hoje',
            balanceTodayTip: 'Calculado a partir dos {{balance}} informados antes da parcela {{number}}. Se mudar, as parcelas a vencer são recalculadas.',
            summaryTitle: 'Vai ficar assim',
            summaryFixed: '{{count}} parcelas restantes · última em {{month}} · {{total}} a pagar',
            summarySac: 'Parcela cai de {{from}} para {{to}} até {{month}}',
            createFinancingCta: 'Criar financiamento',
            createLoanCta: 'Criar empréstimo',
            systemLabel: 'Sistema de amortização',
            systemFixed: 'Parcela fixa',
            systemPrice: 'Price',
            systemSac: 'SAC',
            systemFixedHint: 'Todas as parcelas valem o mesmo. Use quando o banco não disse qual é o sistema — não pede taxa.',
            systemPriceHint: 'Parcela constante até o fim, mas o app separa juros de amortização. Pede a taxa do contrato.',
            systemSacHint: 'A parcela cai um pouco todo mês. É o comum no financiamento imobiliário. Pede taxa e saldo devedor.',
            annualRateLabel: 'Taxa do contrato (% ao ano)',
            annualRatePlaceholder: 'Ex: 8,99',
            annualRateHint: 'Ao ANO, como o banco informa. Se o contrato diz "TR + 8,99% a.a.", informe só 8,99.',
            extraAmountLabel: 'Seguros e taxas por mês (opcional)',
            extraAmountHint: 'MIP/DFI e taxa de administração não entram na fórmula — informe aqui, ou ajuste depois quando o boleto chegar.',
            curveBalanceHint: 'O saldo devedor é a base do cálculo da parcela decrescente.',
            institution: 'Instituição',
            institutionPlaceholder: 'Nome da instituição (opcional)',
            totalInstallments: 'Total de parcelas',
            totalInstallmentsPlaceholder: 'Ex: 60',
            nextInstallment: 'Próxima parcela',
            nextInstallmentPlaceholder: 'Ex: 12',
            dueDateLabel: 'Vencimento da próxima parcela',
            dueDayPill: 'todo dia {{day}}',
            installmentPairLabel: 'Parcela',
            installmentPairOf: 'de',
            dueDateHint: 'Não é a data da contratação: as parcelas vencem todo dia {{day}}.',
            dueDateHintShortMonths: 'Não é a data da contratação: as parcelas vencem todo dia {{day}} — ou no último dia, nos meses mais curtos.',
            lastBalanceLabel: 'Último saldo devedor (opcional)',
            editMonthlyHint: 'Vale para as parcelas que ainda vão vencer — as pagas ficam como estão.',
            editNextDueHelper: 'As parcelas a vencer são reagendadas a partir desta data.',
            editPaidPrefix: '{{paid}} pagas',
            editTotalHelperEditable: 'Dá para mudar o total enquanto nenhuma parcela foi paga.',
            editTotalHelperLocked: 'O total trava depois do primeiro pagamento ou abatimento.',
            editTotalRequired: 'Informe o total de parcelas.',
            editTotalTooLow: 'O total não pode ser menor que a parcela {{number}}.',
        },
        loan: {
            toggle: 'Alguém me deve isso',
            toggleHint: 'Vira saldo a receber em "Quem me deve", fora dos relatórios de gasto',
            amountHint: 'Não entra nos relatórios de gasto — vira saldo a receber em "Quem me deve".',
            toWhom: 'Pra quem',
            personPlaceholder: 'Nome da pessoa',
            scheduleTitle: 'Cronograma de recebimento (opcional)',
            scheduleHint: 'Quando combinaram o pagamento — uma data, parcelas mensais ou "quando der".',
            existingTitle: 'O dinheiro não saiu da minha conta',
            existingHint: 'Venda, racha de conta, ou saída antes do app — só registra o saldo, sem debitar conta',
        },
        refund: {
            title: 'É uma devolução / estorno',
            hint: 'Abate o gasto da categoria no relatório',
        },
        invoiceMonth: {
            refundPrefix: 'Abate na fatura de',
            expensePrefix: 'Entra na fatura de',
            paidWarning: 'Esta fatura já foi paga. O valor vai virar sobra nela e não vira crédito automático na próxima.',
        },
        ignore: {
            title: 'Ignorar',
            hint: 'Fora dos relatórios e do balanço. Continua no saldo e na fatura.',
            a11y: 'Ignorar lançamento na análise',
        },
        // Converter em transferência (ADR 0158): só na edição de receita/despesa avulsa.
        yieldReserva: {
            title: 'Rendimento da caixinha {{name}}',
            hint: 'Fica guardado nela e conta na caixinha, fora das suas receitas. Valor e exclusão se ajustam por lá.',
        },
        convertToTransfer: {
            title: 'Converter em transferência',
            hintExpense: 'Esse dinheiro foi para outra conta sua? Vira transferência entre contas.',
            hintIncome: 'Esse dinheiro veio de outra conta sua? Vira transferência entre contas.',
            a11y: 'Converter lançamento em transferência',
            pickDestination: 'Para qual conta foi?',
            pickSource: 'De qual conta veio?',
            // Folha de confirmação (26/09/2026, à tarde): origem → destino, valor e data, e a
            // outra ponta como interruptor. Antes era um menu "Juntar as duas / Converter só
            // esta" que não mostrava de onde sai nem para onde vai.
            confirmHint: 'Confira de onde sai e para onde vai. Toque numa conta para trocar.',
            from: 'De',
            to: 'Para',
            swap: 'Inverter origem e destino',
            mergeToggle: 'Juntar com a outra ponta',
            mergeFound: '{{description}} · {{amount}} em {{date}}, na conta {{account}}',
            mergeOnHint: 'O outro lançamento sai da lista; os saldos das duas contas não mudam.',
            mergeOffHint: 'Sem juntar, a conta de lá fica com o dinheiro duas vezes: o lançamento que já existe e a transferência.',
            confirm: 'Converter',
        },
        recurrence: {
            title: 'Repetição',
            once: 'Única',
            installment: 'Parcelar',
            recurring: 'Recorrente',
            frequency: 'Frequência',
            weeklyChip: 'Semanal',
            biweeklyChip: 'Quinzenal',
            monthlyChip: 'Mensal',
            bimonthlyChip: 'Bimestral',
            customChip: 'Personalizar',
            repeatsEvery: 'Repete a cada',
            unitDay: 'Dia',
            unitWeek: 'Semana',
            unitMonth: 'Mês',
            unitYear: 'Ano',
            ends: 'Termina',
            endsNever: 'Nunca',
            endsOnDate: 'Em uma data',
            endsAfterCount: 'Após N ocorrências',
            chooseDate: 'Escolher',
            preview: 'Próximas: {{dates}}',
            transferInfo: 'A transferência vai seguir por regra, sem pré-criar 12 lançamentos.',
            generalInfo: 'O app guarda a regra e materializa as próximas ocorrências conforme o vencimento.',
            monthlyDayLabel: 'No dia {{day}}',
            nthWeekdayLabel: 'No {{ordinal}} {{weekday}}',
            weekdays: {
                sunday: 'domingo',
                monday: 'segunda',
                tuesday: 'terça',
                wednesday: 'quarta',
                thursday: 'quinta',
                friday: 'sexta',
                saturday: 'sábado',
            },
            weekdayInitials: {
                sunday: 'D',
                monday: 'S',
                tuesday: 'T',
                wednesday: 'Q',
                thursday: 'Q',
                friday: 'S',
                saturday: 'S',
            },
            ordinals: {
                first: '1º',
                second: '2º',
                third: '3º',
                fourth: '4º',
                fifth: '5º',
                last: 'último',
            },
        },
        recurringSummary: {
            title: 'Recorrência',
            info: '{{frequency}} · alterações seguem com as opções de apenas esta, futuras ou todas.',
        },
        installment: {
            count: 'Parcelas',
            current: 'Parcela atual',
            valueType: 'Valor informado',
            valueTotal: 'Total',
            valuePerInstallment: 'Da parcela',
            fromInstallmentNotice: 'O app vai criar da parcela {{current}}/{{total}} em diante, sem retroativo.',
            previewFrom: 'A partir da {{current}}/{{total}}: {{trackedCount}}x de {{amount}} no app ({{trackedAmount}} projetado)',
            previewSimple: '{{times}}x de {{amount}}',
            previewWithTotal: '{{times}}x de {{amount}} = {{totalAmount}}',
            decreaseCountA11y: 'Menos uma parcela',
            increaseCountA11y: 'Mais uma parcela',
            decreaseCurrentA11y: 'Parcela atual anterior',
            increaseCurrentA11y: 'Próxima parcela atual',
        },
        validation: {
            alertTitle: 'Atenção',
            ok: 'OK',
            checkForm: 'Confira o formulário',
            selectAccount: 'Selecione uma conta',
            selectCreditCard: 'Selecione um cartão de crédito',
            loanPersonRequired: 'Informe quem te deve',
            loanScheduleSum: 'O cronograma de recebimento precisa somar o valor a receber.',
        },
        toast: {
            installmentCreated: 'Parcelamento criado',
            installmentSaved: 'Parcelamento salvo',
            receiptImported: 'Comprovante importado',
            saveFailed: 'Não foi possível salvar',
            transactionGone: 'Este lançamento não existe mais. Abra de novo pela lista.',
        },
        receiptImport: {
            pdfExtractError: 'Não foi possível extrair o valor deste PDF.',
            imageExtractError: 'Não foi possível extrair o valor deste comprovante. Tente com uma imagem mais nítida.',
            cameraPermission: 'Permita o acesso à câmera para fotografar o comprovante.',
        },
        importSheet: {
            title: 'Importar comprovante',
            message: 'Lemos valor, descrição e data do comprovante e preenchemos aqui mesmo.',
            gallery: 'Galeria',
            galleryDescription: 'Screenshot ou foto do comprovante',
            camera: 'Câmera',
            cameraDescription: 'Tirar foto agora',
            pdf: 'PDF',
            pdfDescription: 'Arquivo de comprovante do banco',
        },
        scanOverlay: 'Lendo comprovante...',
        spendGuard: {
            verbTransfer: 'transferir',
            verbSpend: 'lançar',
        },
        deleteDialog: {
            title: 'Excluir transação',
            message: 'A transação vai para a lixeira e o saldo da conta é recalculado. Dá para desfazer no aviso que aparece logo depois.',
            confirm: 'Excluir',
        },
        recurringEditSheet: {
            title: 'Editar transação',
            message: 'Esta transação se repete. O que deseja editar?',
            onlyThis: 'Apenas esta',
            onlyThisDescription: 'Altera só este lançamento.',
            thisAndFuture: 'Esta e futuras',
            thisAndFutureDescription: 'Mantém o histórico e atualiza daqui para frente.',
            all: 'Todas',
            allDescription: 'Reaplica a mudança em toda a série.',
            allConfirmTitle: 'Alterar toda a série?',
            allConfirmMessage_one: 'Isso reescreve o lançamento já registrado desta série, que já está concluído, e todos os futuros. Para preservar o que já foi concluído, use "Esta e futuras".',
            allConfirmMessage_other: 'Isso reescreve os {{count}} lançamentos já registrados desta série (já concluídos: {{settled}}) e todos os futuros. Para preservar o que já foi concluído, use "Esta e futuras".',
            allConfirmAction: 'Alterar todas',
            paidInvoiceMessage: 'Esta parcela se repete. Mudar a fatura da série inteira mexeria numa fatura que você já pagou, então esse escopo não aparece aqui.',
        },
        installmentCardRemovalSheet: {
            message: 'Você está tirando parcelas do cartão. Elas viram despesas na conta escolhida — as futuras ficam pendentes até a data de cada uma.',
            onlyThisDescription: 'Só esta parcela sai da fatura e vai para a conta.',
            thisAndFutureDescription: 'Esta e as próximas saem das faturas e vão para a conta.',
            allDescription: 'A compra inteira sai do cartão e as faturas são recalculadas.',
        },
        recurringDeleteSheet: {
            title: 'Excluir transação',
            message: 'Esta transação se repete. O que você deseja excluir?',
            projectedMessage: 'Esta cobrança ainda não aconteceu. O que você deseja cancelar?',
            onlyThis: 'Apenas esta',
            onlyThisDescription: 'Remove só este lançamento.',
            projectedOnlyThisDescription: 'Pula só esta cobrança; a assinatura continua.',
            thisAndNext: 'Esta e as proximas',
            thisAndNextDescription: 'Apaga esta ocorrência e as seguintes.',
            fromThisDate: 'Desta data em diante',
            fromThisDateDescription: 'Mantem o que ja aconteceu e cancela daqui para frente.',
            all: 'Todas',
            allDescription: 'Exclui toda a serie recorrente.',
        },
    },
    amountInput: {
        keypad: {
            openA11y: 'Editar o valor com o teclado de cálculo',
            add: 'Somar',
            subtract: 'Subtrair',
            multiply: 'Multiplicar',
            divide: 'Dividir',
            decimal: 'Vírgula decimal',
            backspace: 'Apagar',
            backspaceHint: 'Toque apaga um dígito; segure pra limpar tudo',
            confirm: 'Confirmar',
        },
    },
    newTransactionMenu: {
        pocket: 'Caixinha',
        transfer: 'Transferir',
        income: 'Receita',
        creditExpense: 'Despesa cartão',
        expense: 'Despesa',
        cardExpense: 'Despesa',
        cardRefund: 'Estorno',
        close: 'Fechar',
    },
    periodSummary: {
        neutralTitle: 'Saldo neutro',
        neutralSubtitle: 'Sem entradas ou saídas neste recorte',
    },
    quickPocket: {
        stepReserva: 'Guardar em qual caixinha?',
        stepSource: 'De qual conta vem?',
        stepAmount: 'Guardar na caixinha',
        ofTarget: 'de {{amount}}',
        originLabel: 'De onde vem o dinheiro?',
        originAvailable: 'Disponível',
        originNew: 'Dinheiro novo',
        originTransfer: 'Outra conta',
        newHint: 'Entra em {{account}} como ajuste de saldo e já fica guardado na caixinha.',
        transferHint: 'Transfere de {{source}} pra {{account}} e o valor já fica guardado na caixinha.',
        chooseSource: 'Escolher conta de origem',
        submitTransfer: 'Transferir e guardar',
    },
    quickTransfer: {
        defaultDescription: 'Transferência',
        descriptionWithAccounts: 'Transferência {{source}} → {{destination}}',
        today: 'Hoje',
        scheduledSuffix: ' • Agendada',
        stepSource: 'Conta de origem',
        stepDestination: 'Conta de destino',
        stepAmount: 'Valor da transferência',
        amountLabel: 'Valor',
        reservedCaption: '{{amount}} reservado',
        submitRecurring: 'Criar recorrente',
        submitScheduled: 'Agendar transferência',
        submitTransfer: 'Transferir',
        frequent: 'Frequentes',
        dateLabel: 'Data',
        descriptionLabel: 'Descrição',
        recurringInfo: 'A transferência será criada automaticamente a cada período.',
        reservasSection: 'Caixinhas',
        reservaSameAccount: 'Nesta conta · só guarda',
        reservaA11y: 'Caixinha {{name}}, em {{account}}',
    },
    settleSheet: {
        actionTransfer: 'Transferir',
        actionPay: 'Pagar',
        actionReceive: 'Receber',
        amountLabelTransfer: 'Valor da transferência',
        amountLabelPay: 'Valor do pagamento',
        amountLabelReceive: 'Valor recebido',
        dateFallback: 'Data',
        accountFrom: 'De',
        account: 'Conta',
        accountTo: 'Para',
        selectAccountPlaceholder: 'Selecionar conta...',
        scopeHint: 'Como houve ajuste de valor ou conta, você escolhe o alcance no próximo passo.',
        sourceAccountTitle: 'Conta de origem',
        destinationAccountTitle: 'Conta de destino',
        scopeSheetTitle: 'Aplicar ajuste',
        scopeSheetMessage: 'Esta transação faz parte de uma série. Onde deseja aplicar a mudança?',
        scopeSingle: 'Apenas esta',
        scopeFuture: 'Esta e futuras',
        scopeAll: 'Todas',
        partial: {
            modePartial: 'Pagamento parcial',
            modeFull: 'Quitar assim mesmo',
            hintPartial: 'A parcela continua em aberto com {{remaining}}.',
            hintFull: 'A parcela passa a valer {{amount}} e fica quitada.',
        },
        charges: {
            action: 'Juros e multa',
            hint: 'Acréscimo por atraso nesta parcela',
        },
    },
    spendGuard: {
        verbTransfer: 'transferir',
        verbSpend: 'lançar',
        // Notas gravadas no Movimento de resgate (dado criado — segue o idioma da criação).
        rescueNotesTransfer: 'Para transferência',
        rescueNotesExpense: 'Para despesa',
        verbTransferCap: 'Transferir',
        verbSpendCap: 'Lançar',
        availableTitle: 'Só {{amount}} disponível nessa conta',
        submergedTitle: 'As caixinhas já passam do saldo desta conta em {{deficit}}',
        reservedBody_one: '{{reserved}} está guardado numa caixinha. Faltam {{shortfall}} pra {{verb}} {{amount}}.',
        reservedBody_other: '{{reserved}} estão guardados em caixinhas. Faltam {{shortfall}} pra {{verb}} {{amount}}.',
        proceedAnyway: '{{verb}} assim mesmo',
        proceedAnywayHint: 'A conta pode ficar negativa',
        takeFromReserva: 'Tirar de uma caixinha pra completar',
        rescueExact: 'Resgata {{amount}}',
        rescuePartial: 'Resgata o que der ({{amount}})',
        cancel: 'Cancelar',
        pickTitle: 'De qual caixinha?',
        pickBody: 'Vamos resgatar {{amount}} pra completar a {{target}}.',
        targetTransfer: 'transferência',
        targetExpense: 'despesa',
        reservaGuarded: '{{amount}} guardado',
        back: 'Voltar',
    },
    filters: {
        title: 'Filtrar transações',
        clear: 'Limpar',
        // viewCount_zero: filtro sem resultado mostrava "Ver 0 transação" (pt-BR trata 0 como _one).
        viewCount_zero: 'Ver {{count}} transações',
        viewCount_one: 'Ver {{count}} transação',
        viewCount_other: 'Ver {{count}} transações',
        applyGeneric: 'Ver transações',

        // Contas e cartões são multi-seleção (ADR 0170): rótulo no plural, como "Tags".
        accountLabel: 'Contas',
        allAccounts: 'Todas as contas',
        accountModalTitle: 'Filtrar por conta',
        accountsSelected_one: '{{count}} conta',
        accountsSelected_other: '{{count}} contas',
        cardLabel: 'Cartões',
        allCards: 'Todos os cartões',
        cardModalTitle: 'Filtrar por cartão',
        cardsSelected_one: '{{count}} cartão',
        cardsSelected_other: '{{count}} cartões',

        categoryLabel: 'Categoria',
        allCategories: 'Todas as categorias',
        categoryModalTitle: 'Filtrar por categoria',
        categorySearchPlaceholder: 'Buscar categoria ou subcategoria',
        categoryTypeExpensePlural: 'Despesas',
        categoryTypeIncomePlural: 'Receitas',
        noCategoryFound: 'Nenhuma categoria encontrada',

        subcategoryLabel: 'Subcategoria',
        allSubcategories: 'Todas as subcategorias',
        subcategoryModalTitle: 'Filtrar por subcategoria',
        subcategorySearchPlaceholder: 'Buscar subcategoria',

        tagsLabel: 'Tags',
        allTags: 'Todas',
        tagsModalTitle: 'Filtrar por tag',
        tagSearchPlaceholder: 'Buscar tag',
        tagsSelected_one: '{{count}} tag',
        tagsSelected_other: '{{count}} tags',
        noTagsYet: 'Você ainda não criou tags',

        amountLabel: 'Valor',
        anyAmount: 'Qualquer valor',
        amountModalTitle: 'Faixa de valor',
        minAmount: 'Mínimo',
        maxAmount: 'Máximo',
        amountBetween: '{{min}} a {{max}}',
        amountFrom: 'A partir de {{min}}',
        amountUpTo: 'Até {{max}}',
        clearRange: 'Limpar',
        applyRange: 'Aplicar',

        sortLabel: 'Ordenação',
        sortModalTitle: 'Ordenar por',
        sortDirection: 'Direção',
        sortDate: 'Data',
        sortAmount: 'Valor',
        sortCategory: 'Categoria',
        ascending: 'Crescente',
        descending: 'Decrescente',

        displayLabel: 'Exibição e busca',
        displayNone: 'Nenhuma ativa',
        displayActive_one: '{{count}} ativa',
        displayActive_other: '{{count}} ativas',
        displayTitle: 'Exibição e busca',
        groupSearch: 'Busca',
        groupStatement: 'Extrato',
        groupInTransactions: 'Nas transações',
        groupBalances: 'Saldos',
        groupBalancesHint: 'Estas preferências valem sempre — o "Limpar" dos filtros não as desliga.',
        searchInNotes: 'Buscar nas observações',
        searchInNotesTip: 'A busca passa a olhar também a observação de cada lançamento, não só a descrição.',
    },
    listItem: {
        // Receita de rendimento de caixinha na lista (ADR 0164): linha da caixinha, como guardar/resgatar.
        reservaYield: 'Rendimento da caixinha',
        noCategory: 'Sem categoria',
        confirmA11y: 'Marcar como concluída',
        unconfirmA11y: 'Marcar como pendente',
        subtitle: {
            invoice: 'Fatura · {{account}}',
            invoicePayment: 'Pagamento de fatura · {{account}}',
            invoiceManualAdjustment: 'Ajuste manual da fatura',
            loanDisbursement: 'Valor a receber',
            loanScheduledReceipt: 'Data combinada',
            loanReceipt: 'Recebimento de quem me deve',
            balanceAdjustment: 'Ajuste de saldo',
            transfer: '{{source}} → {{destination}}',
        },
        prepayment: 'Abatimento',
        partialPayment: 'Pagamento parcial',
        financing: 'Financiamento',
        status: {
            ignored: 'Ignorado',
            manual: 'Manual',
            manualAdjustment: 'Ajuste manual',
            manualDecrease: 'Ajuste a menor',
            previousBalance: 'Saldo anterior',
            invoice: 'Fatura',
            settlement: 'Liquidação',
            loan: 'A receber',
            excess: 'Excedente',
            writeOff: 'Baixa',
            credit: 'Crédito',
            refund: 'Devolução',
            adjustment: 'Ajuste',
            pending: 'Pendente',
            recurring: 'Recorrente',
        },
    },
};
